module.exports = __webpack_public_path__ + "static/media/scoreUpdate.d728c1c1.svg";